import React from 'react';
import {Controller} from "react-hook-form";
import {countries} from "../../utils/DataList";
import {CheckBox, CheckBoxOutlineBlank} from "@mui/icons-material";
import {Autocomplete, Box, Checkbox, Chip, TextField} from "@mui/material";

const icon = <CheckBoxOutlineBlank fontSize="small"/>;
const checkedIcon = <CheckBox fontSize="small"/>;

export default function CountryMultiSelect(props) {
    const {
        control,
        inputName,
        inputLabel,
        updateCondition = () => null,
        outputKey = null // OPTIONAL: set to "code", "label" or leave null for full object
    } = props;

    const availableOptions = countries.filter((country) => country?.label !== "Global");

    return (
        <Controller
            name={inputName}
            control={control}
            render={({field: {onChange, value, ...fieldProps}}) => {

                // TRANSFORM VALUE FOR UI: Map stored values (could be codes or objects) back to full objects
                const safeValue = Array.isArray(value)
                    ? value.map((item) => {
                        if (typeof item !== 'object') {
                            // If stored value is a primitive (like code), find the matching full object
                            return availableOptions.find((c) => c[outputKey || 'code'] === item);
                        }
                        return item; // If it's already an object, use it directly
                    }).filter(Boolean)
                    : [];

                return (
                    <Autocomplete
                        multiple
                        disableCloseOnSelect={true}
                        id="country-multi-select"
                        isOptionEqualToValue={(option, val) => option?.code === val?.code}
                        getOptionLabel={(option) => option?.label || ""}
                        options={availableOptions}
                        value={safeValue}
                        renderOption={(renderProps, option, {selected, index}) => (
                            <li {...renderProps} key={`${option?.code || 'country'}-${index}`}>
                                <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    sx={{marginRight: "8px", padding: "2px"}}
                                    checked={selected}
                                    color="primary"
                                />
                                {option?.label}
                            </li>
                        )}
                        renderValue={(selected, getTagProps) =>
                            selected?.map((option, index) => {
                                const {key, ...tagProps} = getTagProps({index});
                                return (
                                    <Chip
                                        key={key}
                                        variant="outlined"
                                        color="primary"
                                        size="small"
                                        label={option.label}
                                        {...tagProps}
                                    />
                                );
                            })
                        }
                        renderInput={(params) => (
                            <Box display="flex">
                                <Box flexGrow={1}>
                                    <TextField
                                        {...params}
                                        size="small"
                                        variant="outlined"
                                        margin="dense"
                                        label={inputLabel}
                                    />
                                </Box>
                            </Box>
                        )}
                        onChange={(e, data) => {
                            // TRANSFORM DATA ON CHANGE:
                            // If outputKey is provided, extract that specific value. Otherwise, save the full object.
                            const processedData = outputKey && Array.isArray(data)
                                ? data.map(item => typeof item === 'object' ? item[outputKey] : item).filter(Boolean)
                                : data || [];

                            onChange(processedData);
                            updateCondition(processedData);
                        }}
                        {...fieldProps}
                    />
                );
            }}
        />
    );
}
